import { ILayoutFilter } from '@base/@types/components/Layout/Filters'

export const planFieldsFilter: ILayoutFilter[] = [
  {
    id: 'periodoSelectIds',
    label: 'Periodo',
    filterId: 'periods',
    type: 'select',
    isRequired: true,
    isMulti: false
  },
  {
    id: 'empresaSelectIds',
    label: 'Empresa',
    filterId: 'companies',
    type: 'select',
    isMulti: true
  },
  // {
  //   id: 'mundoSelectIds',
  //   label: 'Mundo',
  //   filterId: 'worlds',
  //   type: 'select',
  //   isMulti: true
  // },
  {
    id: 'categoriaCompactaSelectIds',
    label: 'Categoria Compacta',
    filterId: 'compactCategories',
    type: 'select',
    isMulti: true
  },
  {
    id: 'categoriaSelectIds',
    label: 'Categoria',
    filterId: 'categories',
    type: 'select',
    isMulti: true
  }
]
